import type { FormDialogModel } from './hooks/useFormDialog';
import type { TabItem } from '@/components/custom/erp';
import InfoDropdown from './InfoDropdown';
import BasicInfoTab from './BasicInfoTab';

export const FormHeader = (dialog: FormDialogModel): TabItem[] => [
  {
    id: 'info',
    label: 'Thông tin',
    component: <BasicInfoTab formMode={dialog.formMode} formState={dialog.formState} />
  }
];

export const FormHeaderActions = ({ dialog }: { dialog: FormDialogModel }) =>
  dialog.formMode !== 'add' ? (
    <InfoDropdown uuid={dialog.initialData?.uuid} ma_ct={dialog.initialData?.chung_tu} />
  ) : null;
